<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action>
      <div class="modal-card" style="width: 800px">
        <!-- ヘッダ -->
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke; text-align: left">テンプレート登録</p>
        </header>

        <!-- セクション -->
        <section class="modal-card-body" style="width: 100%; text-align: left">
          <div v-if="data.salesOfficeCode" class="columns">
            <div class="column">
              <b-field label="営業所" labelPosition="on-border">
                <b-input v-if="referenceOffices.length < 1" v-model="officeName" name="officeName" type="text" readonly></b-input>
                <b-select v-else expanded v-model="data.salesOfficeCode">
                  <option
                    v-for="referenceOffice in referenceOffices"
                    :value="referenceOffice.officeCode"
                    :key="referenceOffice.officeCode"
                  >{{ referenceOffice.officeName }}</option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="テンプレート名"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('templateName') }"
                :message="errors.first('templateName')"
              >
                <b-input
                  v-model="data.templateName"
                  name="templateName"
                  data-vv-as="テンプレート名"
                  type="text"
                  v-validate="'required'"
                  maxlength="100"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                label="テンプレート"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('template') }"
                :message="errors.first('template')"
              >
                <b-input
                  v-model="data.template"
                  name="template"
                  type="textarea"
                  data-vv-as="テンプレート"
                  v-validate="'required'"
                  maxlength="512"
                ></b-input>
              </b-field>
            </div>
          </div>
        </section>

        <!-- フッタ -->
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="save()">登録</b-button>
          <b-button v-if="data.id" class="button" type="button" @click="deleteTemplate()">削除</b-button>
          <b-button class="button" type="button" @click="close()">閉じる</b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AppSupportContentsTemplate",
  props: {
    value: { type: Boolean, default: false },
    template: { type: Object, default: null }
  },

  methods: {
    close: function() {
      this.$emit("input", false);
      this.$emit("closed");
      return;
    },

    save: async function() {
      // バリデーション
      const validateRes = await this.$validator.validateAll();
      if (!validateRes) {
        return;
      }

      // WebAPI呼び出し
      let webApi;
      if (this.data.id) {
        webApi = this.setPatientSupportHistoryTemplatePUT;
      } else {
        webApi = this.setPatientSupportHistoryTemplatePOST;
      }
      this.apiCall(webApi, this.webApiSuccess, this.webApiError);
      return;
    },

    deleteTemplate: async function() {
      const confiermRes = await this.showComfirmMessage(
        "このテンプレートを削除します。よろしいですか？"
      );
      if (confiermRes) {
        // WebAPI呼び出し
        this.apiCall(
          this.deletePatientSupportHistoryTemplateDELETE,
          this.webApiSuccess,
          this.webApiError
        );
      }
      return;
    },

    setPatientSupportHistoryTemplatePOST: function(client) {
      const apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryTemplatePOST(
        {
          body: this.data
        }
      );
      return apiRes;
    },

    setPatientSupportHistoryTemplatePUT: function(client) {
      const apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryTemplatePUT(
        {
          body: this.data
        }
      );
      return apiRes;
    },

    deletePatientSupportHistoryTemplateDELETE: function(client) {
      const apiRes = client.apis.apiPatientSupport.deletePatientSupportHistoryTemplateDELETE(
        {
          id: this.data.id
        }
      );
      return apiRes;
    },

    webApiSuccess: function(result) {
      this.showSuccess(result);
      this.close();
      return;
    },

    webApiError: function(result) {
      this.showErrorMessage(result);
      return;
    },

    initData: function() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userInfo = userInfo;

      const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));

      const office = officeMaster.find(
        elem => elem.officeCode == userInfo.officeCode
      );
      this.officeName = office.officeName;

      this.referenceOffices.splice(0);
      for (const referenceOfficeCode of userInfo.referenceOfficeCodes) {
        const referenceOffice  = officeMaster.find(
          elem => elem.officeCode == referenceOfficeCode
        );
        this.referenceOffices.push(referenceOffice);
      }

      if (this.template) {
        this.data = JSON.parse(JSON.stringify(this.template));
      } else {
        this.data = {
          salesOfficeCode:
            !(this.userInfo.roleId == 1 || this.userInfo.roleId == 2) ? userInfo.officeCode : null,
          templateName: null,
          template: null
        };
      }

      return;
    }
  },

  data() {
    return {
      userInfo: {},
      officeName: null,
      referenceOffices: [],
      data: {
        salesOfficeCode: null,
        templateName: null,
        template: null
      }
    };
  },

  watch: {
    value: function() {
      if (this.value) {
        this.initData();
      }
      return;
    }
  },

  filters: {},

  components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupportContentsTemplate.vue